import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { spaceMapToPixel } from '../../LayoutUtils'
import { Spacing } from '../../LayoutTypes'
import { BackgroundColorTypes } from '../../../Theme/Fonts/FontTypes'
import { TestID } from '../../../utils/PropTypesDefinitions'

// TODO: do we really need the space? I just found usages of standard space in NewsOne (except Skeletons which may be wrong implemented)
export type CardEndProps = {
    space?: Spacing
    backgroundColor?: BackgroundColorTypes
} & TestID

const CardEnd: FunctionComponent<CardEndProps> = ({
    space,
    backgroundColor = 'tahitian-3',
    testID,
}): ReactElement => {
    return (
        <Grid noExpand backgroundColor={backgroundColor} testID={testID}>
            <Grid noExpand height={8} position="relative">
                <Grid noExpand height={6} elevation={1} backgroundColor="pearl" marginTop={1} />
                {/* small overlayer to hide shadow at top of the component */}
                <Grid
                    noExpand
                    position="absolute"
                    height={3}
                    backgroundColor="pearl"
                    width="100%"
                />
            </Grid>
            <Grid noExpand height={spaceMapToPixel.get(space) || 0} />
        </Grid>
    )
}

export default memo(CardEnd)
